import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import Navbar from './Partial/Navbar'
import Footer from './Partial/Footer'
import About from './About'
import Contact from '../UserComponents/Contact'
import Error404 from '../UserComponents/Error404'
import ShopDetail from '../UserComponents/ShopDetail'

import AdminHome from '../AdminComponents/AdminHome'

import AdminMaincategory from '../AdminComponents/AdminMaincategory/AdminMaincategory'
import AdminCreateMaincategory from '../AdminComponents/AdminMaincategory/AdminCreateMaincategory'
import AdminUpdateMaincategory from '../AdminComponents/AdminMaincategory/AdminUpdateMaincategory'

import AdminSubcategory from '../AdminComponents/AdminSubcategory/AdminSubcategory'
import AdminCreateSubcategory from '../AdminComponents/AdminSubcategory/AdminCreateSubcategory'
import AdminUpdateSubcategory from '../AdminComponents/AdminSubcategory/AdminUpdateSubcategory'

import AdminBrand from '../AdminComponents/AdminBrand/AdminBrand'
import AdminCreateBrand from '../AdminComponents/AdminBrand/AdminCreateBrand'
import AdminUpdateBrand from '../AdminComponents/AdminBrand/AdminUpdateBrand'

import AdminTestimonial from '../AdminComponents/AdminTestimonial/AdminTestimonial'
import AdminCreateTestimonial from '../AdminComponents/AdminTestimonial/AdminCreateTestimonial'
import AdminUpdateTestimonial from '../AdminComponents/AdminTestimonial/AdminUpdateTestimonial'

import AdminProduct from '../AdminComponents/AdminProduct/AdminProduct'
import AdminCreateProduct from '../AdminComponents/AdminProduct/AdminCreateProduct'
import AdminUpdateProduct from '../AdminComponents/AdminProduct/AdminUpdateProduct'
import Product from './Product'
import SignUp from './SignUp'
import Login from './Login'
import Profile from './Profile'
import UpdateProfile from './UpdateProfile'
import Cart from './Cart'
import Checkout from './Checkout'
import Confirmation from './Confirmation'
import Wishlist from './Wishlist'
import Order from './Order'
import OrderDetail from './OrderDetail'
import AdminNewsletter from '../AdminComponents/AdminNewsletter/AdminNewsletter'
import AdminUser from '../AdminComponents/AdminUser/AdminUser'
import AdminContactUs from '../AdminComponents/AdminContactUs/AdminContactUs'
import AdminContactUsShow from '../AdminComponents/AdminContactUs/AdminContactUsShow'
import AdminOrder from '../AdminComponents/AdminOrder/AdminOrder'
import AdminOrderShow from '../AdminComponents/AdminOrder/AdminOrderShow'
import Loader from './Partial/Loader'
import ForgetPassword from './ForgetPassword'
import MatchOtp from './MatchOtp'
import ResetPassword from './ResetPassword'
import Payment from './Payment'
const Home = lazy(() => import('../UserComponents/Home'))
const Shop = lazy(() => import('../UserComponents/Shop'))

export default function App() {
    const Layout = ({ children }) => {
        const location = useLocation();
        const isAdminPath = location.pathname.startsWith('/admin') || location.pathname.startsWith('/login') || location.pathname.startsWith('/signup') || 
        location.pathname.startsWith('/update-profile') || location.pathname.startsWith('/otp-sender') || location.pathname.startsWith('/match-otp') || location.pathname.startsWith('/reset-password')

        return (
            <div>
                {!isAdminPath && <Navbar />}
                {children}
                {!isAdminPath && <Footer />}
            </div>
        );
    }

    return (
        <BrowserRouter>
            <Layout>
                <Suspense fallback={<Loader />}>
                    <Routes>
                        {/* public route */}
                        <Route path='/' element={<Home />} />
                        <Route path='/about' element={<About />} />
                        <Route path='/shop' element={<Shop />} />
                        <Route path='/shop-detail' element={<ShopDetail />} />
                        <Route path='/product/:_id' element={<Product />} />
                        <Route path='/contact' element={<Contact />} />

                        {/* user route */}
                        {
                            localStorage.getItem("login") && localStorage.getItem("role") === "Buyer" ?
                                <>
                                    <Route path='/profile' element={<Profile />} />
                                    <Route path='/update-profile' element={<UpdateProfile />} />
                                    <Route path='/cart' element={<Cart />} />
                                    <Route path='/checkout' element={<Checkout />} />
                                    <Route path='/payment/:_id' element={<Payment />} />
                                    <Route path='/wishlist' element={<Wishlist />} />
                                    <Route path='/order' element={<Order />} />
                                    <Route path='/order_detail/:_id' element={<OrderDetail />} />
                                    <Route path='/confirmation' element={<Confirmation />} />
                                </> : <Route path='*' element={<Error404/>} />
                        }

                        {/* authentication route */}
                        <Route path='/signup' element={<SignUp />} />
                        <Route path='/login' element={<Login />} />
                        <Route path='/otp-sender' element={<ForgetPassword />} />
                        <Route path='/match-otp' element={<MatchOtp />} />
                        <Route path='/reset-password' element={<ResetPassword />} />

                        {/* admin route */}
                        {
                            localStorage.getItem("login") && localStorage.getItem("role") === "Admin" ?
                                <>
                                    <Route path='/admin' element={<AdminHome />} />
                                    <Route path='/update-profile' element={<UpdateProfile />} />
                                    <Route path='/admin/maincategory' element={<AdminMaincategory />} />
                                    <Route path='/admin/maincategory/create' element={<AdminCreateMaincategory />} />
                                    <Route path='/admin/maincategory/update/:_id' element={<AdminUpdateMaincategory />} />

                                    <Route path='/admin/subcategory' element={<AdminSubcategory />} />
                                    <Route path='/admin/subcategory/create' element={<AdminCreateSubcategory />} />
                                    <Route path='/admin/subcategory/update/:_id' element={<AdminUpdateSubcategory />} />

                                    <Route path='/admin/brand' element={<AdminBrand />} />
                                    <Route path='/admin/brand/create' element={<AdminCreateBrand />} />
                                    <Route path='/admin/brand/update/:_id' element={<AdminUpdateBrand />} />

                                    <Route path='/admin/testimonial' element={<AdminTestimonial />} />
                                    <Route path='/admin/testimonial/create' element={<AdminCreateTestimonial />} />
                                    <Route path='/admin/testimonial/update/:_id' element={<AdminUpdateTestimonial />} />

                                    <Route path='/admin/product' element={<AdminProduct />} />
                                    <Route path='/admin/product/create' element={<AdminCreateProduct />} />
                                    <Route path='/admin/product/update/:_id' element={<AdminUpdateProduct />} />

                                    <Route path='/admin/newsletter' element={<AdminNewsletter />} />
                                    <Route path='/admin/users' element={<AdminUser />} />

                                    <Route path='/admin/contacts' element={<AdminContactUs />} />
                                    <Route path='/admin/contacts/show/:_id' element={<AdminContactUsShow />} />

                                    <Route path='/admin/checkout' element={<AdminOrder />} />
                                    <Route path='/admin/checkout/show/:_id' element={<AdminOrderShow />} />
                                </> : <Route path='*' element={<Error404/>} />
                        }
                    </Routes>
                </Suspense>
            </Layout>
        </BrowserRouter>
    )
}


